// Product page preorder buttons for DETOXMAG O2™
setTimeout(function(){
    // Only run on the detoxmag-o2-™ product page
    if (document.body && document.body.id === 'detoxmag-o2-™') {
        
        let formObserver = null; // Track observer to prevent duplicates
        
        // Function to update button text
        function updatePreorderButtons() {
            // 1. Subscribe Now button
            const subscribeButton = document.querySelector('[data-recurpay-action]');
            if (subscribeButton) {
                subscribeButton.textContent = 'PREORDER NOW - SHIPS APRIL 21ST';
            }
            
            // 2. Main Add to Cart button (for one-time purchase)
            const atcButton = document.querySelector('button[id*=AddToCart][type=submit]');
            if (atcButton) {
                atcButton.textContent = 'PREORDER NOW - SHIPS APRIL 21ST';
            }
        }
        
        // Initial update
        updatePreorderButtons();
        
        // Setup observer only once
        if (!formObserver) {
            const productForm = document.querySelector('[data-product-form]');
            if (productForm) {
                formObserver = new MutationObserver(function(mutations) {
                    // Debounce to prevent excessive calls
                    clearTimeout(formObserver.timer);
                    formObserver.timer = setTimeout(updatePreorderButtons, 50);
                });
                
                formObserver.observe(productForm, { 
                    childList: true, 
                    subtree: true
                });
            }
        }
        
        // Listen for radio button changes (quantity selection)
        const quantityRadios = document.querySelectorAll('input[name*="options[Quantity]"]');
        quantityRadios.forEach(function(radio) {
            radio.addEventListener('change', updatePreorderButtons, { once: false });
        });
        
        // Listen for subscription/one-time toggle
        const purchaseTypeRadios = document.querySelectorAll('input[name="recurpay__group_main"]');
        purchaseTypeRadios.forEach(function(radio) {
            radio.addEventListener('change', updatePreorderButtons, { once: false });
        });
        
        console.log("Preorder buttons updated for detoxmag-o2-™");
    }
}, 300);

// Side cart preorder message for DETOXMAG O2™
function addPreorderMessageToCart() {
    const cartItems = document.querySelectorAll('.cart__item[data-item-title="DETOXMAG O2 ™"],.cart__item[data-item-title="DETOXMAG O2 ™ - 1 Bottle"],.cart__item[data-item-title="DETOXMAG O2 ™ - 2 Bottles"]');
    
    cartItems.forEach(function(item) {
        // Check if preorder message already exists
        if (item.querySelector('.preorder-message')) return;
        
        // Find the meta section where we'll add the message
        const metaSection = item.querySelector('.cart__item__meta');
        
        if (metaSection) {
            // Create the preorder message element
            const preorderMsg = document.createElement('p');
            preorderMsg.className = 'preorder-message';
            preorderMsg.style.cssText = 'margin: 5px 0 0 0; font-size: 12px; color: #666; font-weight: 500;';
            preorderMsg.textContent = 'PREORDER - SHIPS APRIL 21ST';
            
            metaSection.appendChild(preorderMsg);
        }
    });
}

// Run when cart opens or updates
document.addEventListener('DOMContentLoaded', function() {
    addPreorderMessageToCart();
    
    // Watch for cart updates (when items are added/removed/quantity changed)
    const observer = new MutationObserver(function() {
        addPreorderMessageToCart();
    });
    
    const cartDrawer = document.querySelector('cart-items, [data-items-holder]');
    if (cartDrawer) {
        observer.observe(cartDrawer, { childList: true, subtree: true });
    }
});

// Also run when cart drawer opens (some themes use specific events)
document.addEventListener('cart:refresh', addPreorderMessageToCart);
document.addEventListener('theme:cart:open', addPreorderMessageToCart);